import axios from "axios";
import { API_BASE } from "../utils/apiConfig";

/**
 * Fetches Google reviews data from backend
 * Public endpoint - no authentication required
 * 
 * @returns {Promise<{rating: number, user_ratings_total: number, reviews: Array}>}
 */
export const getGoogleReviews = async () => {
  const response = await axios.get(
    `${API_BASE}/google-reviews`,
    { skipAuth: true }  // Public endpoint - don't send Bearer token
  );
  
  if (response.data?.status === 'OK' && response.data?.result) {
    return response.data.result;
  }
  
  throw new Error('Invalid response format from Google reviews API');
};
